import { fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { store } from "../store";
import { showGlobalToast } from "../../../src/Components/ToastProvider";
import router from "../../../src/Routes";
import { logout } from "../Slices/actions";

const rawBaseQuery = fetchBaseQuery({
  baseUrl: import.meta.env.VITE_API,
  prepareHeaders: (headers, { getState }) => {
    const token = getState().userSlice?.token;
    if (token) {
      headers.set("Authorization", `Bearer ${token}`);
    }
    return headers;
  },
});

export const customFetchBase =
  ({ url }) =>
  async (args, api, extraOptions) => {
    const fixedArgs = {
      ...args,
      url: url + (args.url || ""),
    };

    const result = await rawBaseQuery(fixedArgs, api, extraOptions);

    if (result?.error?.status === 401) {
      showGlobalToast("لظفا دوباره وارد شوید");
      store.dispatch(logout());
      router.navigate("/auth");
    }

    return result;
  };

// READ‌ME
// in default it will send token and json type , but
// you cant override headers or send more in query of RTK
